// extracted by mini-css-extract-plugin
module.exports = {"icon":"GoogleIcon_icon_3jWBS","google":"GoogleIcon_google_3vGo4","img":"GoogleIcon_img_MVsY3"};